module.exports = __webpack_public_path__ + "img/013.9d2545f0.png";